import { call, put, takeEvery } from "redux-saga/effects";
import { authActions } from "./authSlice";
import { getDetail, login, loadIrLevelMapping } from "./authBaseApi";
import { toastAction } from "../toast/toast";

export function* onSubmitAuth({ payload }) {
  try {
    payload.setIsPending(true);
    const loginSucc = yield call(login, { ...payload?.formValues });
    yield put(authActions.fetchUserLoginSucceeded(loginSucc));

    const data = yield call(loadIrLevelMapping);
    yield put(authActions.setLevelMapping(data));

    payload?.postLoginAction();
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message));
  } finally {
    payload.setIsPending(false);
  }
}
export function* getUserData() {
  try {
    const loginSucc = yield call(getDetail);
    yield put(authActions.fetchUserDetailSave(loginSucc));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message));
  }
}

function* authWatcherSaga() {
  yield takeEvery(authActions.loginDispatch.type, onSubmitAuth);
  yield takeEvery(authActions.fetchUserDetail.type, getUserData);
}

export default authWatcherSaga;
